import { useEffect, useState } from 'react';
import { getPublicCatalogItem } from '../../lib/api';
import { applyItemMetadata } from '../../app/seo';
import { siteIdentity } from '../../content/siteContent';
import { mediaUrl } from '../components/BlockRenderer';
import { formatPrice } from '../../lib/format';
import { NotFoundPage } from './NotFoundPage';
import type { CatalogItem } from '../../lib/types';

export function CatalogItemPage({ slug }: { slug: string }) {
  const [item, setItem] = useState<CatalogItem | null | undefined>(undefined);

  useEffect(() => {
    getPublicCatalogItem(slug).then(setItem).catch(() => setItem(null));
  }, [slug]);

  useEffect(() => {
    if (item) applyItemMetadata(`${siteIdentity.catalogPath}/${item.slug}`, item.name, item.summary);
  }, [item]);

  if (item === undefined) {
    return <section className="not-found" aria-label="Loading item"><p>Loading…</p></section>;
  }

  if (!item) return <NotFoundPage />;

  return (
    <article>
      <header className={`page-hero${item.imageId ? ' page-hero--image' : ''}`} style={item.imageId ? { backgroundImage: `url(${mediaUrl(item.imageId)})` } : undefined}>
        <h1>{item.name}</h1>
        <p className="page-hero__lead">{formatPrice(item.priceCents)}</p>
      </header>
      <section className="prose"><p>{item.description}</p></section>
      <p>
        <a className="button" aria-label={`Ask about ${item.name}`} href={`/contact?type=General&item=${item.slug}`}>Ask about this</a>
      </p>
    </article>
  );
}
